import { Row } from "exceljs";

export const COLORS = {
	HEADER_FILL: "C6EFCE",
	STATUS: {
		SUBMITTED: "9FE1CB",
		MISSED: "F5C4B3",
		PENDING: "D3D1C7",
	},
	RATE: {
		HIGH: "9FE1CB",
		MID: "FFEDA0",
		LOW: "F5C4B3",
	},
} as const;

export const CURRENCY_FMT = "£#,##0.00";

export const applyHeaderStyle = (row: Row): void => {
	row.font = { bold: true, color: { argb: "1A1A1A" } };
	row.fill = {
		type: "pattern",
		pattern: "solid",
		fgColor: { argb: COLORS.HEADER_FILL },
	};
	row.alignment = { vertical: "middle", horizontal: "left" };
};

export const rateFillArgb = (pct: number | null | undefined): string | null => {
	if (pct === null || pct === undefined) return null;
	if (pct >= 80) return COLORS.RATE.HIGH;
	if (pct >= 50) return COLORS.RATE.MID;
	return COLORS.RATE.LOW;
};

export const statusFillArgb = (status: string): string | null => {
	const map: Record<string, string> = {
		// Event submissions / approval states — positive
		SUBMITTED: COLORS.STATUS.SUBMITTED,
		APPROVED: COLORS.STATUS.SUBMITTED,
		COMPLETED: COLORS.STATUS.SUBMITTED,
		PENDING_APPROVAL: COLORS.STATUS.SUBMITTED,
		// Enrollment "Active" — in progress, positive
		ACTIVE: COLORS.STATUS.SUBMITTED,
		// Negative / final-bad
		MISSED: COLORS.STATUS.MISSED,
		EXPIRED: COLORS.STATUS.MISSED,
		SKIPPED: COLORS.STATUS.MISSED,
		REJECTED: COLORS.STATUS.MISSED,
		DELIVERY_FAILED: COLORS.STATUS.MISSED,
		// Enrollment ended early — negative
		DISENROLLED: COLORS.STATUS.MISSED,
		// Pending / paused — neutral / moderate
		PENDING: COLORS.STATUS.PENDING,
		SCHEDULED: COLORS.STATUS.PENDING,
		PAUSED: COLORS.RATE.MID,
	};
	return map[status] ?? null;
};

export const filenameSlug = (programName: string): string =>
	programName
		.toLowerCase()
		.replace(/\s+/g, "-")
		.replace(/[^a-z0-9-]/g, "");

export const isoDateOnly = (date: string | undefined): string =>
	date ? date.slice(0, 10) : "all";
